<dx-popup
    [title]="dialogHeader"
    [width]="600"
    [height]="'auto'"
    [(visible)]="visible"
    [hideOnOutsideClick]="false"
    (onHiding)="onHiding($event)"
>
    @if (!readOnly) {
        <dxi-popup-toolbar-item
            widget="dxButton"
            location="after"
            [options]="{ text: 'Save', type: 'success', onClick: save }"
            [disabled]="processing"
        ></dxi-popup-toolbar-item>
    }
    @if (!readOnly) {
        <dxi-popup-toolbar-item
            widget="dxButton"
            location="after"
            [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }"
            [disabled]="processing"
        ></dxi-popup-toolbar-item>
    }
    @if (readOnly) {
        <dxi-popup-toolbar-item
            widget="dxButton"
            location="after"
            [options]="{ text: 'Close', type: 'default', onClick: cancel }"
            [disabled]="processing"
        ></dxi-popup-toolbar-item>
    }
    @if (formData) {
        <dx-form [formData]="formData" [readOnly]="readOnly" validationGroup="mainValidationGroup">
            @if (isSingleEmail || sendToMode) {
                <dxi-form-item dataField="to">
                    <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
                </dxi-form-item>
            }
            <dxi-form-item dataField="cc"> </dxi-form-item>
            <dxi-form-item dataField="bcc"> </dxi-form-item>
            <dxi-form-item dataField="subject"> </dxi-form-item>
            <dxi-form-item dataField="body" editorType="dxTextArea" [editorOptions]="{ height: 350 }"> </dxi-form-item>
            @if ((mode === 'Invoice' || mode === 'Payment' || mode === 'Open Invoices') && isSingleEmail) {
                <dxi-form-item [label]="{ text: 'Report' }">
                    <div *dxTemplate>
                        <a [routerLink]="[]" (click)="openReport()">{{ reportName }}</a>
                    </div>
                </dxi-form-item>
            }
        </dx-form>
    }
</dx-popup>
